import React from "react";
import { Outlet} from "react-router-dom";
import styled from "styled-components";
import axios from "axios";

const backendApp = process.env.REACT_APP_BACKEND_URL
export default function Navbar() {

const onCreatNewThread = async () => {
  const sent = await axios.post(`${backendApp}/start`);
  const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('thread-id', sent.data.thread.id);
    window.history.pushState(null, '', '?' + searchParams.toString());
    window.location.reload();
} 

  return (
    <>
      <div
        style={{
          // float: "right",
          display: "flex",
          height: "60px",
          alignItems: "center",
          justifyContent: 'center'
        }}
      >
        {/* {location.pathname === "/" && (
          <Button
            onClick={() =>
              dispatch(
                chatSectionUpdate(
                  chatSection === "chats" ? "contacts" : "chats"
                )
              )
            }
          >
            {chatSection === "chats" ? "New Chat" : "Back"}
          </Button>
        )}
        {location.pathname !== "/" && (
          
        )}
        <Button onClick={handleClick}>
          <BiPowerOff />
        </Button> */}
        <div style={{width: '82%', display: 'flex', justifyContent: 'space-between'}}>

              <p style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>GM-Lighting Chatbot</p>
        <Button
            onClick={() =>
              onCreatNewThread()
            }
          >
            Create New Thread
          </Button>
        </div>
      </div>
      <Outlet />
    </>
  );
}

const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  margin: 5px;
  border-radius: 0.5rem;
  background-color: #9a86f3;
  border: none;
  cursor: pointer;
  svg {
    font-size: 1.3rem;
    color: #ebe7ff;
  }
`;
